// Swimming duration (excluding rests) is stored independently of total training
// duration, so it is deliberately never sent from this form: the API keeps it.
// Likewise the end is never client-authored: the API derives it from the start and
// duration (or moves a stored legacy end with the start) so the two stay consistent.
export const buildWorkoutUpdatePayload = ({
    workoutStart,
    trainingDurationMin,
    trainingDurationSec,
    volume,
    status
}) => ({
    workoutStart: new Date(workoutStart).toISOString(),
    trainingDurationMin,
    trainingDurationSec,
    volume,
    status
});
